import React, { useEffect, useState } from 'react';
import { collection, doc, getDoc, getDocs, query } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { db } from '../firebase.js';
import { formatDate } from '../common/formatDate.js';
import { describeGame } from '../common/describeGame.js';
import { compareGames } from '../common/compareGames.js';
import GameTypeBadge from './GameTypeBadge.js';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'in-person', label: 'In-Person' },
  { key: 'online', label: 'Online' },
];

export default function Games() {
  const navigate = useNavigate();
  const [players, setPlayers] = useState(null);
  const [games, setGames] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    getDoc(doc(db, 'homepage', 'standings')).then(snap => {
      const data = snap.exists() ? snap.data().players ?? {} : {};
      setPlayers(Object.entries(data).map(([id, p]) => ({ id, ...p })));
    });

    getDocs(query(collection(db, 'games'))).then(snap => {
      const all = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      all.sort(compareGames);
      setGames(all);
    });
  }, []);

  if (players === null || games === null) return <p>Loading…</p>;

  const nameFor = id => players.find(p => p.id === id)?.name ?? '';
  const visibleGames = filter === 'all' ? games : games.filter(g => g.type === filter);

  return (
    <div className="panel w-100">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap" style={{ gap: '0.75rem' }}>
        <h2 className="section-title mb-0">All Games</h2>
        <ButtonGroup>
          {FILTERS.map(f => (
            <Button
              key={f.key}
              variant={filter === f.key ? 'primary' : 'outline-primary'}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      {visibleGames.length === 0 && <p>No games yet.</p>}
      {visibleGames.map(g => (
        <div
          key={g.id}
          className="recent-game-row"
          onClick={() => navigate(`/games/${g.id}`)}
          style={{ cursor: 'pointer' }}
        >
          <span>{describeGame(g, nameFor)} {filter === 'all' && <GameTypeBadge type={g.type} />}</span>
          <span className="text-muted recent-game-date">{formatDate(g.datePlayed)}</span>
        </div>
      ))}
    </div>
  );
}
